export default {"src":"/_next/static/media/chats-icon.d62c0802.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};